import { render, staticRenderFns } from "./NewContentsManabi.vue?vue&type=template&id=4b0c6f52&scoped=true&"
import script from "./NewContentsManabi.vue?vue&type=script&lang=ts&"
export * from "./NewContentsManabi.vue?vue&type=script&lang=ts&"
import style0 from "./NewContentsManabi.vue?vue&type=style&index=0&id=4b0c6f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c6f52",
  null
  
)

export default component.exports